import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./AgriFreshLanding.module.scss";

import Veggies from "../../assets/mp4/Veggies.mp4";
import AgriFreshLogo from "../../assets/png/AgriFreshLogo.png";

export default class AgriFreshLanding extends Component {
  render() {
    return (
      <section id={styles.AgriFreshLanding}>
        <div className={styles.videoContainer}>
          <video
            className={styles.videoVeggies}
            controls={false}
            preload="auto"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={Veggies} type="video/mp4"></source>
          </video>
        </div>
        <Container className={styles.landingContainer}>
          <Row>
            <Col md={12}>
              <Image src={AgriFreshLogo} id={styles.Logo} />
            </Col>
            <Col md={12}>
              <p id={styles.TextBox}>
                fresh <br></br> & crisp, <br></br> for up to <br></br> 5x
                longer.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
